import {
  IFilter,
  TFilterOperator,
  TFilterType,
} from '../../../types/models/FilterSort'

export const formatFiltersSorts = (
  filters: Record<string, TFilterType>,
  sorts: Record<string, '' | 'asc' | 'desc'>
) => {
  const convertedFilters: IFilter[] = Object.entries(filters)
    .filter(
      ([_, { filterType, value }]) =>
        filterType && value !== '' && typeof value !== 'boolean'
    )
    .map(([field, { filterType, value, filterField }]) => ({
      field: filterField || field,
      operator: filterType as TFilterOperator,
      value: value as string | number | Date,
    }))

  const sort_by: string[] = []
  const sort_desc: boolean[] = []

  if (sorts) {
    Object.entries(sorts).forEach(([field, direction]) => {
      if (direction) {
        sort_by.push(field)
        sort_desc.push(direction === 'desc')
      }
    })
  }

  return {
    filters: convertedFilters,
    sort_by,
    sort_desc,
  }
}
